import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ENV } from "./lib/env";
import { initKeitaro } from "./lib/keitaro";

// Initialize Keitaro with URL parameters
if (window.keitaro) {
  // Get URL parameters for tracking
  const urlParams = new URLSearchParams(window.location.search);
  const trackingParams = {};

  // Common tracking parameters
  [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "click_id",
    "sub_id",
  ].forEach((param) => {
    if (urlParams.has(param)) {
      trackingParams[param] = urlParams.get(param);
    }
  });

  // Initialize with any URL parameters
  initKeitaro(trackingParams);

  // Don't update script if already set in HTML
  // Only update if using environment variables
  if (ENV.KEITARO_CAMPAIGN_URL !== "http://155.138.200.99/fLwg11") {
    console.log("Using Keitaro configuration from environment variables");
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
